<template>
    <div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL TOPOGRAPHIC SETTING</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="setting in topographicSettingSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="setting.topographicSettingId">
                        <label>{{setting.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">Geographic Division</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="division in geographicDivisionSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="division.geographicDivisionId">
                        <label>{{division.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">UNIQUE SITE SETTING</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="setting in uniqueSettingSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="setting.uniqueSettingId">
                        <label>{{setting.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">BARE GROUND PERCENTAGE</label>
            <div class="col-md-3">
                <div class="form-control">{{siteSetting.percentBareGround}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL TOPOGRAPHIC SETTING</label>
            <div class="col-md-4">
                <div class="form-control">{{siteSetting.generalTopographicSetting}}</div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">VEGETATION ASSOCIATION</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="type in vegetationTypeSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="type.vegetationTypeId">
                        <label>{{type.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">GENERAL DEPOSITIONAL ENVIRONMENT</label>
            <div class="col-md-10">
                <div class="row well">
                    <div v-for="type in depositionalTypeSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="type.depositionalTypeId">
                        <label>{{type.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">AEOLIAN SETTINGS</label>
            <div class="col-md-3">
                <label><span>Late Pleistocene and Holocene aeolian deposits</span></label>
                <div class="form-control">{{aeolianTypeLabel}}</div>
            </div>
            <div class="col-md-7" v-show="siteSetting.aeolianSettingsId == 1">
                <label><span>Type(s) of aeolian setting(s)</span></label>
                <div class="row well">
                    <div v-for="type in aeolianTypeSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="type.aeolianTypeId">
                        <label>{{type.description}}</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2 control-label">SUBSURFACE POTENTIAL</label>
            <div class="col-md-3">
                <label><span>Archaeological subsurface deposits</span></label>
                <div class="form-control">{{subsurfacePotentialLabel}}</div>
            </div>
            <div class="col-md-7"  v-show="siteSetting.subsurfacePotentialId == 1">
                <label><span>Estimate based on</span></label>
                <div class="row well">
                    <div v-for="deposit in depositEstimateBasisSelectedList" class="col-md-3 checkbox checkbox-inline">
                        <input readonly type="checkbox" v-model="deposit.depositEstimateBasisId">
                        <label>{{deposit.description}}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import siteSettingService from '../../services/siteForm/siteSettingService'

export default {
    name: 'siteSettingForm',
    components: {
    },
    props: ['crrId'],
    data: function () {
        return {
            isDebug: false,
            aeolianTypeSelectedList: [],
            depositEstimateBasisSelectedList: [],
            depositionalTypeSelectedList: [],
            topographicSettingSelectedList: [],
            uniqueSettingSelectedList: [],
            vegetationTypeSelectedList: [],
            geographicDivisionSelectedList: [],
            siteSetting: {}
        }
    },
    computed: {
        aeolianTypeLabel: function () {
            switch (this.siteSetting.aeolianSettingsId) {
            case 1:
                return 'Yes'
            case 2:
                return 'No'
            case 3:
                return 'Unknown'
            case 4:
                return 'Not Applicable'
            default:
                return ''
            }
        },
        subsurfacePotentialLabel: function () {
            switch (this.siteSetting.subsurfacePotentialId) {
            case 1:
                return 'Yes'
            case 2:
                return 'No'
            case 3:
                return 'Unknown'
            case 4:
                return 'Not Applicable'
            default:
                return ''
            }
        }
    },
    mounted () {
        // this.isLoading = true
        // this.loadData().then(result => {
        //     this.isLoading = false
        // })
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Setting Form', message)
        },
        loadAeolianTypes () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchAeolianType(this.$http, searchDto).then(result => {
                this.aeolianTypeSelectedList = siteSettingService.getAeolianTypeList().filter(type => {
                    return result.data.some(x => x.aeolianTypeId === type.aeolianTypeId)
                })
                return result
            })
        },
        loadDepositEstimateBasis () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDepositEstimateBasis(this.$http, searchDto).then(result => {
                this.depositEstimateBasisSelectedList = siteSettingService.getDepositEstimateBasisList().filter(deposit => {
                    return result.data.some(x => x.depositEstimateBasisId === deposit.depositEstimateBasisId)
                })
                return result
            })
        },
        loadDepositionalType () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDepositionalType(this.$http, searchDto).then(result => {
                this.depositionalTypeSelectedList = siteSettingService.getDepositionalTypeList().filter(type => {
                    return result.data.some(x => x.depositionalTypeId === type.depositionalTypeId)
                })
                return result
            })
        },
        loadTopographySetting () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingTopography(this.$http, searchDto).then(result => {
                this.topographicSettingSelectedList = siteSettingService.getTopographicSettingList().filter(setting => {
                    return result.data.some(x => x.topographicSettingId === setting.topographicSettingId)
                })
                return result
            })
        },
        loadUniqueSetting () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingUniqueSetting(this.$http, searchDto).then(result => {
                this.uniqueSettingSelectedList = siteSettingService.getUniqueSettingList().filter(setting => {
                    return result.data.some(x => x.uniqueSettingId === setting.uniqueSettingId)
                })
                return result
            })
        },
        loadVegetationTypes () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingVegetation(this.$http, searchDto).then(result => {
                this.vegetationTypeSelectedList = siteSettingService.getVegetationTypeList().filter(type => {
                    return result.data.some(x => x.vegetationTypeId === type.vegetationTypeId)
                })
                return result
            })
        },
        loadDivisions () {
            var searchDto = {siteSettingId: this.siteSetting.siteSettingId}
            return siteSettingService.searchSiteSettingDivision(this.$http, searchDto).then(result => {
                this.geographicDivisionSelectedList = siteSettingService.getGeographicDivisionList().filter(division => {
                    return result.data.some(x => x.geographicDivisionId === division.geographicDivisionId)
                })
                return result
            })
        },
        loadData () {
            this.log('Searching site settings for ' + this.crrId)
            return siteSettingService.searchSiteSetting(this.$http, {culturalResourceRecordingId: this.crrId}).then(response => {
                if (response.data.length > 0) {
                    this.log('found a response')
                    this.siteSetting = response.data[0]
                    Promise.all([
                        this.loadAeolianTypes(),
                        this.loadDepositEstimateBasis(),
                        this.loadDepositionalType(),
                        this.loadTopographySetting(),
                        this.loadUniqueSetting(),
                        this.loadVegetationTypes(),
                        this.loadDivisions()
                    ]).then(response2 => {
                        this.log('done loading others')
                        return response2
                    })
                } else {
                    this.log('no response found')
                }
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteSetting.vue?581f5cd2